import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0F172A] text-slate-300 py-16 border-t border-slate-800" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-64">
          {/* Company Info */}
          <div data-id="element-65">
            <h3 className="text-white text-xl font-bold mb-4" data-id="element-66">
              Plubos Kabeltechniek B.V.
            </h3>
            <p className="text-sm leading-relaxed mb-6 text-slate-400" data-id="element-67">
              Infra- en elektrotechnisch aannemingsbedrijf. Sinds 1977 uw
              betrouwbare partner voor complexe projecten.
            </p>
            <div className="flex items-center gap-2 text-sm text-[#F57C00]" data-id="element-68">
              <Clock className="w-4 h-4" data-id="element-69" />
              <span data-id="element-70">Sinds 1977 – Landelijk opererend</span>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-71">
            <h4 className="text-white font-semibold mb-6" data-id="element-72">Contact</h4>
            <div className="space-y-4 text-sm leading-relaxed" data-id="element-73">
              <div className="flex items-start gap-3" data-id="element-74">
                <MapPin className="w-5 h-5 text-[#F57C00] mt-0.5 flex-shrink-0" data-id="element-75" />
                <div data-id="element-76">
                  <p className="text-slate-300" data-id="element-77">
                    Vestiging Alkmaar (postadres)
                  </p>
                  <p className="text-slate-300" data-id="element-78">Diamantweg 68</p>
                  <p className="text-slate-300" data-id="element-79">1812 RC ALKMAAR</p>
                  <p className="text-slate-400 text-xs mt-1" data-id="element-80">
                    (deze locatie is te bereiken via de Barnsteenstraat en
                    vervolgens de Diamantweg inrijden)
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-81">
                <Phone className="w-5 h-5 text-[#F57C00] mt-0.5 flex-shrink-0" data-id="element-82" />
                <a href="tel:+31725626656" className="hover:text-white transition-colors" data-id="element-83">
                  +31 (0) 72 5626656
                </a>
              </div>
              <div className="flex items-start gap-3" data-id="element-84">
                <Mail className="w-5 h-5 text-[#F57C00] mt-0.5 flex-shrink-0" data-id="element-85" />
                <div data-id="element-86">
                  <a href="mailto:alkmaar@plubos.nl" className="hover:text-white transition-colors block" data-id="element-87">
                    alkmaar@plubos.nl
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-88">
                <Mail className="w-5 h-5 text-[#F57C00] mt-0.5 flex-shrink-0" data-id="element-89" />
                <div data-id="element-90">
                  <p className="text-slate-400 text-xs mb-0.5" data-id="element-91">Facturen:</p>
                  <a href="mailto:crediteurenadministratie@plubos.nl" className="hover:text-white transition-colors" data-id="element-92">
                    crediteurenadministratie@plubos.nl
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-93">
            <h4 className="text-white font-semibold mb-6" data-id="element-94">Diensten</h4>
            <ul className="space-y-2 text-sm" data-id="element-95">
              <li data-id="element-96">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-97">
                  Grondwerk
                </a>
              </li>
              <li data-id="element-98">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-99">
                  Kabelwerk
                </a>
              </li>
              <li data-id="element-100">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-101">
                  Elektrowerk
                </a>
              </li>
              <li data-id="element-102">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-103">
                  Montagewerk
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-105">
                  Brandwerende doorvoeringen
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-106">
            <h4 className="text-white font-semibold mb-6" data-id="element-107">Informatie</h4>
            <ul className="space-y-2 text-sm" data-id="element-108">
              <li data-id="element-109">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-110">
                  Over ons
                </a>
              </li>
              <li data-id="element-111">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-112">
                  Certificeringen
                </a>
              </li>
              <li data-id="element-113">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-114">
                  Projecten
                </a>
              </li>
              <li data-id="element-115">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-116">
                  Vacatures
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-[#F57C00] transition-colors" data-id="element-118">
                  Privacyverklaring
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center text-sm text-slate-500" data-id="element-119">
          <p data-id="element-120">
            &copy; {new Date().getFullYear()} Plubos Kabeltechniek B.V. Alle
            rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>;
}